export const checkFakeToken = (error: any) => {
  if (!error || !error.response) {
    return;
  }

  const { error: errorMessage } = error.response.data || {};
  if (
    !errorMessage ||
    (errorMessage !== "logout" && errorMessage !== "Token empty or invalid")
  ) {
    return;
  }

  localStorage.clear();
  localStorage.removeItem("authToken");
  window.location.reload();
};
